import { createRouter, createWebHistory } from 'vue-router'
import HomePage from './components/HomePage.vue'
import SchoolPage from './components/SchoolPage.vue'
import LoginPage from './components/LoginPage.vue'
import HallPage from './components/HallPage.vue'
import RegisterPage from './components/RegisterPage.vue'
import ResetPasswordPage from './components/ResetPasswordPage.vue'
import NoteEdit from './components/NoteEdit.vue'
import NoteDetail from './components/NoteDetail.vue'
import VideoPlayer from './components/VideoPlayer.vue'
import NotFind from './components/NotFind.vue'

const routes = [
  { path: '/', name: 'Home', component: HomePage },
  { path: '/school', name: 'School', component: SchoolPage,  meta: { requiresAuth: true } },
  {path: '/hall', name: 'Hall', component: HallPage,  meta: { requiresAuth: true }},
  { path: '/login', name: 'Login', component: LoginPage },
  { path: '/register', name: 'Register', component: RegisterPage},
  { path: '/reset-password', name: 'ResetPassword', component: ResetPasswordPage },
  { path: '/note-edit', name: 'NoteEdit', component: NoteEdit },
  { path: '/note-detail/:id/:type', name: 'NoteDetail', component: NoteDetail,  meta: { requiresAuth: true } },
  {path: '/video-player', name: 'VideoPlayer', component: VideoPlayer,  meta: { requiresAuth: true }},
  {path: '/:pathMatch(.*)*', name: 'NotFind', component: NotFind},
]


const router = createRouter({
  history: createWebHistory(),
  routes,
})


// ✅ 全局前置守卫
router.beforeEach((to, from, next) => {
  // 1. 获取登录状态（从 localStorage 或 Pinia/Vuex）
  const isLoggedIn = localStorage.getItem('token') // 或 useAuthStore().isAuthenticated
  // 2. 判断目标页面是否需要登录
  if (to.meta.requiresAuth) {
    if (isLoggedIn) {
      // 已登录，放行
      next()
      console.log('已登录')
    } else {
      // 未登录，跳转到登录页，并记录原目标（以便登录后跳回）
      console.log('未登录')
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 保存原地址
      })
    }
  } else {
    // 不需要登录的页面（如首页、登录页），直接放行
    next()
  }
})
export default router 